import * as React from 'react';

import { styled } from '@mui/material/styles';

const StyledSVG = styled('svg')(() => ({
  height: '45px',
  marginRight: '7px',
  marginBottom: '10px',
}));

export const CvLogo = () => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 351"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="CV_Icon_Red_Filled"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="CV_Icon_Grey" transform="translate(46.000000, 71.000000)">
          <circle
            id="Oval"
            stroke="#CE0E2D"
            strokeWidth="6"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            cx="330.63047"
            cy="176.45092"
            r="28.17"
          />
          <circle
            id="Oval"
            stroke="#CE0E2D"
            strokeWidth="6"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            cx="73.6104704"
            cy="176.45092"
            r="28.17"
          />
          <path
            d="M330.64047,167.100915 C334.4231,167.096874 337.835517,169.372362 339.285871,172.865895 C340.736224,176.359429 339.938748,180.382669 337.265455,183.058825 C334.592162,185.73498 330.569777,186.536761 327.074694,185.090146 C323.57961,183.643532 321.30047,180.233551 321.30047,176.45092 C321.30047,171.29096 325.480514,167.106439 330.64047,167.100915"
            id="Shape"
            fill="#CE0E2D"
            fillRule="nonzero"
          />
          <path
            d="M73.6404704,167.10092 C78.8043329,167.10092 82.9904704,171.287057 82.9904704,176.45092 C82.9904704,181.614782 78.8043329,185.80092 73.6404704,185.80092 C68.476608,185.80092 64.2904704,181.614782 64.2904704,176.45092 C64.2904704,173.971146 65.2755569,171.592937 67.029022,169.839471 C68.7824872,168.086006 71.1606963,167.10092 73.6404704,167.10092"
            id="Shape"
            fill="#CE0E2D"
            fillRule="nonzero"
          />
          <path
            d="M401.43047,139.49092 C386.29047,118.28092 297.82047,114.76092 297.82047,114.76092 C297.82047,114.76092 286.727596,108.696815 273.448934,101.914378 C269.732591,100.016154 261.610633,105.428401 257.747131,103.534836 C252.74638,101.083886 252.020329,91.3682723 247.523603,89.3755962 C241.885222,86.8770088 236.975928,84.9384526 233.63047,84.0609199 C188.53047,72.2409199 134.09047,78.2909199 116.98047,80.7109199 C99.8704704,83.1309199 39.2104704,105.27092 28.6404704,108.06092 C18.4304704,110.75092 7.43047044,108.90092 8.64047044,114.76092 C9.85047044,120.62092 8.64047044,141.13092 4.32047044,146.29092 C1.65047044,149.48092 -0.569529558,154.17092 0.130470442,161.43092 C0.830470442,168.69092 2.50047044,177.43092 2.50047044,177.43092 L46.3104704,183.49092 C43.3182621,172.071839 47.7631285,159.998234 57.4453498,153.245211 C67.1275711,146.492188 79.9933698,146.492188 89.6755911,153.245211 C99.3578124,159.998234 103.802679,172.071839 100.81047,183.49092 L101.73047,183.49092 L304.02047,185.86092 C299.834684,174.025056 303.98632,160.847767 314.200718,153.548825 C324.415116,146.249883 338.226728,146.591104 348.068237,154.385536 C357.909747,162.179968 361.405614,175.546193 356.64047,187.16092 C382.16047,187.16092 407.72047,184.71092 403.07047,177.83092 C401.00047,174.77092 403.63047,157.73092 403.81047,151.41092 C404.18047,140.62092 401.43047,139.49092 401.43047,139.49092 Z"
            id="Path"
            stroke="#CE0E2D"
            strokeWidth="5"
            fill="#CE0E2D"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.1904704,87.2009199 C92.1904704,87.2009199 81.6304704,101.36092 84.9804704,109.73092 L116.79047,111.41092 L183.49047,114.76092 L175.96047,77.0409199 C161.914273,77.01364 150.038818,77.3333333 140.334106,78 C112.216431,79.931548 92.1904704,87.2009199 92.1904704,87.2009199 Z"
            id="Path"
            stroke="#CE0E2D"
            strokeWidth="5"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="5"
            strokeLinejoin="round"
            points="87.5915527 106.325272 180.119019 112.097687 281.16047 122.85092"
          />
          <circle
            id="Oval"
            stroke="#CE0E2D"
            strokeWidth="10"
            cx="263"
            cy="91"
            r="13"
          />
          <path
            d="M319,90 C313.936972,61.3479544 286.492088,31.1980325 240,39.3553233"
            id="Oval-Copy"
            stroke="#CE0E2D"
            strokeWidth="12"
          />
          <path
            d="M354,78 C346.373414,35.0219316 305.032386,-10.2029513 235,2.03298496"
            id="Oval-Copy-2"
            stroke="#CE0E2D"
            strokeWidth="12"
          />
        </g>
      </g>
    </StyledSVG>
  );
};
